import { render, staticRenderFns } from "./MailRegistry.vue?vue&type=template&id=54b96eda&scoped=true&"
import script from "./MailRegistry.vue?vue&type=script&lang=ts&"
export * from "./MailRegistry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b96eda",
  null
  
)

export default component.exports